import {
  OPEN_ADMIN_ROLES_MODAL,
  CLOSE_ADMIN_ROLES_MODAL,
  OPEN_ADMIN_USER_MODAL,
  CLOSE_ADMIN_USER_MODAL,
  OPEN_HEADER_MODAL,
  CLOSE_HEADER_MODAL,
  EDIT_BOOKING_MODAL,
  CANCEL_BOOKING_MODAL,
  CANCEL_MANUAL_BOOKING_MODAL,
  SET_USER_TYPE,
  UPDATE_TRIP_STATUS,
  VIEW_VEHICLE_INFO


} from '../constants';

export default function modalReducer(state = {}, action) {
  switch (action.type) {
    case OPEN_ADMIN_ROLES_MODAL:
      return {
        ...state,
        adminRolesModal: action.payload.adminRolesModal,
        adminRolesModalType: action.payload.adminRolesModalType
      };

    case CLOSE_ADMIN_ROLES_MODAL:
      return {
        ...state,
        adminRolesModal: action.payload.adminRolesModal,
        adminRolesModalType: null
      };

    case OPEN_ADMIN_USER_MODAL:
      return {
        ...state,
        adminUserModal: action.payload.adminUserModal,
        adminUserModalType: action.payload.adminUserModalType
      };

    case CLOSE_ADMIN_USER_MODAL:
      return {
        ...state,
        adminUserModal: action.payload.adminUserModal,
        adminUserModalType: null
      };

    case OPEN_HEADER_MODAL:
      return {
        ...state,
        [action.payload.modalType]: action.payload.actionValue
      };

    case CLOSE_HEADER_MODAL:
      return {
        ...state,
        [action.payload.modalType]: action.payload.actionValue
      };

    case EDIT_BOOKING_MODAL:
      return {
        ...state,
        editBookingModal: action.payload.editBookingModal
      };

    case CANCEL_BOOKING_MODAL:
      return {
        ...state,
        cancelBookingModal: action.payload.cancelBookingModal,
        cancelData: action.payload.cancelData,
        userType: 1
      };

    case CANCEL_MANUAL_BOOKING_MODAL:
      return {
        ...state,
        cancelManualBookingModal: action.payload.cancelManualBookingModal
      };

    case SET_USER_TYPE:
      return {
        ...state,
        userType: action.payload.userType
      };
    
    case UPDATE_TRIP_STATUS:
      return{
        ...state,
        updateTripStatus: action.payload.updateTripStatus,
        updateData: action.payload.updateData
      };
    case VIEW_VEHICLE_INFO:
      return{
        ...state,
        modalShow: action.payload.modalShow
      };

    default:
      return {
        ...state,
      };
  }
}
